'use strict';

import Highcharts from 'highcharts/highcharts';
window.Highcharts = Highcharts;

class Chart {
    constructor() {
        'ngInject';

        window.Highcharts.setOptions({
            lang: {
                thousandsSep: ','
            }
        });

        this.template = '<div class="chart"></div>';
        this.restrict = 'E';
        this.replace = true;
        this.scope = { chartConfig: '=value' };
    }

    link(scope, element, attrs) {
        var chartsDefaults = {
            chart: {
                renderTo: element[0],
                type: attrs.type || null,
                height: attrs.height || null,
                width: attrs.width || null,
                style: { fontFamily: "'Unica One', sans-serif" },
                plotBorderColor: '#606063'
            },
            title: {
                style: {
                    color: '#333333',
                    textTransform: 'uppercase',
                    fontSize: '20px'
                }
            },
            subtitle: { style: { color: '#666666' } },
            xAxis: {
                gridLineColor: '#c1c1c1',
                labels: { style: { color: '#0e0e0e'} },
                lineColor: '#c1c1c1',
                minorGridLineColor: '#505053',
                tickColor: '#c1c1c1',
                title: { style: { color: '#0e0e0e' } },
                minPadding: 0,
                maxPadding: 0
            },
            yAxis: {
                title: {
                    style: {
                        color: '#0e0e0e',
                        fontSize: '15px'
                    }
                },
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }],
                gridLineColor: '#c1c1c1',
                labels: { style: { color: '#0e0e0e' } },
                lineColor: '#c1c1c1',
                minorGridLineColor: '#c1c1c1',
                tickColor: '#c1c1c1',
                tickWidth: 1
            },
            legend: {
              itemStyle: {
                color: '#717171'
              },
              itemHoverStyle: {
                color: '#4e4e4e'
              },
              borderWidth: 0
            },
            plotOptions: {
              column: {
                grouping: false,
                borderColor: '#8e8d8d'
              }
            },
            credits:   { enabled: false },
            exporting: { enabled: false },
            tooltip:   { enabled: true  },
            labels: { style: { color: '#666666' } },
            legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
            background2: '#505053',
            dataLabelsColor: '#B0B0B3',
            textColor: '#C0C0C0',
            contrastTextColor: '#F0F0F3',
            maskColor: 'rgba(255,255,255,0.3)'
        };

        //Update when charts data changes
        scope.$watch((scope) => scope.chartConfig.series, (newValue, oldValue, scope) => {
            if(!newValue) return;
            let config = angular.merge({}, chartsDefaults, scope.chartConfig);
            let chart = Highcharts.chart(element[0], config);
        });
    }
}

export default angular.module('leptonApp.Chart', [])
    .directive('chart', [() => new Chart()])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/chart/chart.directive.js